var NotificationTabs;
(function (NotificationTabs) {
    NotificationTabs["GENERAL"] = "generals";
    NotificationTabs["NON_WORKING_DAYS"] = "nonWorking";
})(NotificationTabs || (NotificationTabs = {}));
export default NotificationTabs;
